import { Plus } from "@phosphor-icons/react";
import clsx from "clsx";
import { useState } from "react";

import { LabelsDropdownMenu } from "features/labels/components";
import LabelTag from "features/labels/components/LabelTag";
import type { Label } from "features/labels/types";

import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import useLeadLabelsMutations from "common/datahooks/useLeadLabelsMutations";

const MAX_LABELS = 2;

export default function DesktopLabels({
  profileId,
  labels,
}: {
  labels: Label[];
  profileId: string;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const { removeLeadLabel, addLeadLabel } = useLeadLabelsMutations();

  function toggleLabel(label: Label, isSelected: boolean) {
    (isSelected ? onRemoveLabel : onAddLabel)(label);
  }

  function onAddLabel(label: Label) {
    return addLeadLabel({ label, profileId });
  }
  function onRemoveLabel(label: Label) {
    removeLeadLabel({ label, profileId });
  }
  return (
    <LabelsDropdownMenu
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      labels={labels}
      toggleLabel={toggleLabel}
      onAddLabel={onAddLabel}
    >
      <div className="gap-1.5 flex">
        <div className="flex overflow-hidden items-center gap-1.5">
          {labels.slice(0, MAX_LABELS).map((label) => (
            <LabelTag
              key={label.id}
              label={label}
              size="md"
              className="overflow-hidden flex-1 max-w-max"
            />
          ))}
          {labels.length > MAX_LABELS && (
            <Tag variant="tertiary" size="md" asChild>
              <button type="button" onClick={() => setIsOpen(true)}>
                +{labels.length - MAX_LABELS}
              </button>
            </Tag>
          )}
        </div>

        <Tooltip>
          <TooltipTrigger asChild>
            <Tag
              variant="tertiary"
              size="md"
              asChild
              className={clsx(
                "ml-auto",
                isOpen && "visible",
                "invisible group-hover/table-row:visible",
              )}
            >
              <button type="button" onClick={() => setIsOpen(true)}>
                <Plus />
              </button>
            </Tag>
          </TooltipTrigger>
          <TooltipContent>Add label</TooltipContent>
        </Tooltip>
      </div>
    </LabelsDropdownMenu>
  );
}
